module.exports = __webpack_public_path__ + "img/email-code-validation.34e6e3a7.svg";